<template>
  <div id="app">
    <Header/>
    <ShoppingCart/>
    <ShowAlert/>
    <router-view/>
  </div>
</template>

<script>
import Header from '@/components/common/header'
import ShoppingCart from '@/components/shopping_cart'
import ShowAlert from '@/components/common/show_alert'
import MyCookies from '@/utils/my_cookies'

export default {
  name: 'App',
  components: {
    Header,
    ShoppingCart,
    ShowAlert
  },
  mounted () {
    // console.log(MyCookies.checkCookie())
    const userInfo = localStorage.getItem('userInfo')
    /**
     * 检查cookie，做出相应操作,前端的cookie过期时间比服务端用户过期时间小一点，以免混入授权问题
     */
    // if (!MyCookies.checkCookie()) {

    if (!userInfo) {
      // cookie过期后自动跳转到登陆界面
      const query = this.$route.query
      this.$router.push({ path: '/p/login',  query })
    } else {
      // let userInfo = JSON.parse(this.cookieToJson()['user_info'])
      // 设置用户基本信息
      this.$store.commit('set_user_info', JSON.parse(userInfo))
      this.getMoneyConfirm()
    }
  },
  methods: {
    /**
     * 将cookie转化为对象
     */
    cookieToJson () {
      let cookieArr = document.cookie.split(";");
      let obj = {}
      cookieArr.forEach((i) => {
          let arr = i.split("=");
          obj[arr[0]] =arr[1];
      });
      return obj
    },
    // 获取菜金确认情况
    getMoneyConfirm () {
      this.APIS.GET_MONEY_CONFIRM()
      .then(res => {
        if (res.data.status === 0) {
          this.$store.commit('set_is_feedback', res.data.is_check)
        } else {
          this.$store.commit('show_alert', res.data.message)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
#app {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  min-height: 600px;
  background-color: #fafafa;
}
</style>



// WEBPACK FOOTER //
// src/App.vue